import React, { Component } from "react"
import {
	Alert,
	Button,
	Form,
	FormControl,
	FormGroup,
	Glyphicon,
	HelpBlock,
	Modal,
	OverlayTrigger,
	Tab,
	Table,
	Tabs,
	Tooltip,
	Well,
	Checkbox,
} from "react-bootstrap"
import { formatPrice, formatGain } from "./format"
import * as firebase from "firebase"
import TransactionsTable from "./TransactionsTable"
import { price } from "./vendor/cryptocompare"

export default class HoldingsTable extends Component {
	static defaultProps = {
		holdings: {},
	}

	// stupid bs couldn't get imports inside arrow functions how does this shit work
	priceFunction(fsym, tsym) {
		return price(fsym, tsym)
	}

	constructor(props) {
		super(props)
		this.state = {
			sort: "exchange",
			parsedHoldings: {},
			renderHoldings: [],
			isCompact: isSmallWindow(),
			accordionOpenMap: {},
			averageCostModal: null,
			averageCost: {},
			error: null,
			shouldHideZeroBalances: false,
		}
		this.settingsUnsubscribe = null
	}

	componentDidMount() {
		const toAdd = this.parseHoldings(this.props.holdings)
		const renderHoldings = this.createRenderHoldings(toAdd)
		this.createCombinedHoldings(renderHoldings).then(combinedHoldings => {
			Object.keys(combinedHoldings).forEach(key => {
				renderHoldings.push(combinedHoldings[key])
			})
			this.setState({
				parsedHoldings: toAdd,
				renderHoldings: renderHoldings,
			})
			window.addEventListener("resize", this.handleWindowResize)
			this.setSettingsListener()
		})
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevProps.holdings !== this.props.holdings ||
			prevProps.transactions !== this.props.transactions ||
			prevProps.isPremium !== this.props.isPremium ||
			prevState.averageCost !== this.state.averageCost
		) {
			const toAdd = this.parseHoldings(this.props.holdings)
			const renderHoldings = this.createRenderHoldings(toAdd)
			this.createCombinedHoldings(renderHoldings).then(combinedHoldings => {
				renderHoldings.push.apply(renderHoldings, combinedHoldings)

				this.setState({
					parsedHoldings: toAdd,
					renderHoldings: renderHoldings,
				})
			})
		}
		if (prevProps.uid !== this.props.uid) {
			this.setSettingsListener()
		}
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleWindowResize)
		if (this.settingsUnsubscribe !== null) {
			this.settingsUnsubscribe()
		}
	}

	setSettingsListener() {
		if (this.settingsUnsubscribe !== null) {
			this.settingsUnsubscribe()
		}
		if (!this.props.uid) {
			return
		}
		this.settingsUnsubscribe = firebase
			.firestore()
			.collection("settings")
			.doc(this.props.uid)
			.onSnapshot(doc => {
				if (!doc.exists) {
					this.setState({
						averageCost: {},
					})
					return
				}
				const { averageCost, shouldHideZeroBalances } = doc.data()
				this.setState({
					averageCost,
					shouldHideZeroBalances,
				})
			})
	}

	parseHoldings(toAdd) {
		const parsedHoldings = {}
		Object.keys(toAdd).forEach(function(exchange) {
			const data = []
			Object.keys(toAdd[exchange]["assets"]).forEach(function(symbol) {
				const nextData = toAdd[exchange]["assets"][symbol]
				nextData["exchangeID"] = exchange
				nextData["exchange"] = toAdd[exchange].name
				nextData["name"] = symbol
				data.push(nextData)
			})
			parsedHoldings[exchange] = data
		})

		Object.keys(parsedHoldings).forEach(key =>
			parsedHoldings[key].map(this.addRenderData, this)
		)
		return parsedHoldings
	}

	createRenderHoldings(parsedHoldings) {
		const renderHoldings = []
		Object.keys(parsedHoldings)
			.sort(this.alphabetSort)
			.forEach(function(key) {
				const exchangeArray = []
				Object.keys(parsedHoldings[key]).forEach(function(key2) {
					exchangeArray.push(parsedHoldings[key][key2])
				})
				exchangeArray.sort((a, b) => (a["name"] < b["name"] ? -1 : 1))
				renderHoldings.push.apply(renderHoldings, exchangeArray)
			})
		return renderHoldings
	}

	// creates the data for the Combined tab: combines same assets across multiple exchanges into one row
	async createCombinedHoldings(renderHoldings) {
		const combinedHoldings = {}
		for (let holding of renderHoldings) {
			const name = holding["name"]
			const alreadyExists = combinedHoldings[name]
			// if this isn't the first time we've seen this  name
			if (alreadyExists !== undefined) {
				// new Average Cost calculations: average cost over quantity
				const alreadyAvgCost = alreadyExists["averageCost"]
				const alreadyQuantity = alreadyExists["quantity"]
				const toAddAvgCost = holding["averageCost"]
				const toAddQuantity = holding["quantity"]
				const newAverageCost =
					alreadyAvgCost === null || toAddAvgCost === null
						? null
						: (alreadyAvgCost * alreadyQuantity +
								toAddAvgCost * toAddQuantity) /
							(alreadyQuantity + toAddQuantity)
				// new Book Value calculations: plain addition
				const alreadyBookValue = alreadyExists["bookValue"]
				const toAddBookValue = holding["bookValue"]
				const newBookValue =
					alreadyBookValue === null || toAddBookValue === null
						? null
						: toAddBookValue + alreadyBookValue
				// new Exchange : Combined so it cleanly works with renderHoldingsTable
				// Note: exchanges still saved in exchangeID field
				const newExchanges = "Combined"
				// new ExchangesID: string concat with a ","
				const alreadyExchangeID = alreadyExists["exchangeID"]
				const toAddExchangeID = holding["exchangeID"]
				const newExchangesID = alreadyExchangeID + "," + toAddExchangeID
				// new Market Value calculations: plain addition
				// NOTE: market value is mutable because we may change it if quote mismatch
				const alreadyMarketValue = alreadyExists["marketValue"]
				const toAddMarketValue = holding["marketValue"]
				var newMarketValue = alreadyMarketValue + toAddMarketValue
				// new Name: same
				const newName = name
				// new Portfolio Percent: plain addition
				const alreadyPortfolioPercent = alreadyExists["portfolioPercent"]
				const toAddPortfolioPercent = holding["portfolioPercent"]
				const newPortfolioPercetn =
					alreadyPortfolioPercent + toAddPortfolioPercent
				// new price: pick first exchange, keep it (for simplicity)
				const newPrice = alreadyExists["price"]
				// new quantity: simple addition.
				// Note: fields already exist due to average cost
				const newQuantity = alreadyQuantity + toAddQuantity
				// new unrQain: averaged over quantity
				const alreadyUnrGain = alreadyExists["unrGain"]
				const toAddUnrGain = holding["unrGain"]
				const newUnrGain =
					alreadyUnrGain === null || toAddUnrGain === null
						? null
						: (alreadyUnrGain * alreadyQuantity +
								toAddUnrGain * toAddQuantity) /
							(alreadyQuantity + toAddQuantity)

				// new Quote: check if difference between two, if difference, convert to alreadyQuote
				const alreadyQuote = alreadyExists["quote"]
				const toAddQuote = holding["quote"]
				if (toAddQuote !== alreadyQuote) {
					const pricePromise = this.priceFunction(toAddQuote, alreadyQuote)
					const price = await pricePromise

					newMarketValue =
						alreadyMarketValue + toAddMarketValue * price[alreadyQuote]
				}
				const newQuote = alreadyQuote

				combinedHoldings[name] = {
					averageCost: newAverageCost,
					bookValue: newBookValue,
					exchange: newExchanges,
					exchangeID: newExchangesID,
					marketValue: newMarketValue,
					name: newName,
					portfolioPercent: newPortfolioPercetn,
					price: newPrice,
					quantity: newQuantity,
					quote: newQuote,
					unrGain: newUnrGain,
				}
			} else {
				// keep track of seeing this name already, change exchange to Combined
				if (holding["quantity"] !== 0) {
					const newHolding = Object.assign({}, holding)
					newHolding["exchange"] = "Combined"
					combinedHoldings[name] = newHolding
				}
			}
		}
		const combinedHoldingsArr = []
		Object.keys(combinedHoldings).forEach(key => {
			this.addRenderData(combinedHoldings[key], this)
			combinedHoldingsArr.push(combinedHoldings[key])
		})
		const toReturn = combinedHoldingsArr.sort((a, b) =>
			this.alphabetSort(a["name"], b["name"])
		)
		return toReturn
	}

	sortHoldings(header) {
		if (
			header === "averageCost" ||
			header === "bookValue" ||
			header === "gainValue"
		) {
			return
		}
		if (header === "marketValue") {
			header = "portfolioPercent"
		}
		let renderHoldings = this.state.renderHoldings
		const toFlip = this.state.sort === header
		const numericHeaders = [
			"quantity",
			"price",
			"averageCost",
			"marketValue",
			"bookValue",
			"gainValue",
			"portfolioPercent",
		]
		if (numericHeaders.includes(header)) {
			renderHoldings.sort((a, b) =>
				this.numericSort(
					toFlip ? b[header] : a[header],
					toFlip ? a[header] : b[header]
				)
			)
		} else if (header === "exchange") {
			const { parsedHoldings } = this.state
			renderHoldings = []
			Object.keys(parsedHoldings)
				.sort((a, b) => this.alphabetSort(toFlip ? b : a, toFlip ? a : b))
				.forEach(function(key) {
					const exchangeArray = []
					Object.keys(parsedHoldings[key]).forEach(function(key2) {
						exchangeArray.push(parsedHoldings[key][key2])
					})
					exchangeArray.sort((a, b) => (a["name"] < b["name"] ? -1 : 1))
					renderHoldings.push.apply(renderHoldings, exchangeArray)
				})
		} else {
			renderHoldings.sort((a, b) =>
				this.alphabetSort(
					toFlip ? b[header] : a[header],
					toFlip ? a[header] : b[header]
				)
			)
		}
		const newFlip = header === this.state.sort ? header + "flip" : header
		this.setState({
			sort: newFlip,
			renderHoldings: renderHoldings,
		})
	}

	numericSort(a, b) {
		if (a === "N/A") {
			return 1
		}
		if (b === "N/A") {
			return -1
		}
		return parseFloat(a) > parseFloat(b) ? 1 : -1
	}

	alphabetSort(a, b) {
		return a < b ? -1 : 1
	}

	render() {
		const { renderHoldings } = this.state
		let exchanges = []
		renderHoldings.forEach(holding => exchanges.push(holding["exchange"]))
		// removed Combined so we can move it to the end
		exchanges = [...new Set(exchanges.sort((a, b) => this.alphabetSort(a, b)))]
		delete exchanges[exchanges.indexOf("Combined")]
		exchanges.unshift("All")
		exchanges.push("Combined")
		if (exchanges.length <= 2) {
			return (
				<div>
					<p>
						<b>Welcome to Crypto Portfolio Tracker!</b>
					</p>
					<p>
						To get started, connect an exchange account in the <b>Accounts</b>{" "}
						panel below.
					</p>
					<p className="text-small">
						If you recently added an exchange account, try refreshing the page
						to get updated data.
					</p>
				</div>
			)
		}
		if (exchanges.length <= 3) {
			return this.renderHoldingsTable("All")
		} else {
			return (
				<Tabs defaultActiveKey={0} id="holdings-tab">
					{exchanges.map((exchange, index) => (
						<Tab eventKey={index} title={exchange} key={index + 1}>
							{this.renderHoldingsTable(exchange)}
						</Tab>
					))}
				</Tabs>
			)
		}
	}

	renderHoldingsTable(exchange) {
		const { uid } = this.props
		const { averageCostModal, isCompact, shouldHideZeroBalances } = this.state
		const headerText = [
			["Exchange", "exchange"],
			["Asset", "name"],
			["Quantity", "quantity"],
			["Price", "price"],
			["Average Cost", "averageCost"],
			["Market Value", "marketValue"],
			["Book Value", "bookValue"],
			["Unr. Gain", "gainValue"],
			["% of Portfolio", "portfolioPercent"],
		]
		const name = "table-header"
		const headers = !isCompact
			? headerText.map(h => this.renderHoldingsTableHeader(h, name))
			: headerText.map(h => this.renderHoldingsTableHeaderCompact(h, name))
		const data = this.formatTableData(exchange)
		return (
			<div className={`holdings-table${isCompact ? " compact-table" : ""}`}>
				<Table responsive hover>
					<thead>
						<tr>{headers}</tr>
					</thead>
					<tbody>{data}</tbody>
				</Table>
				{isCompact ? (
					<p className="overview-text">
						<Glyphicon glyph="info-sign" /> Rotate to landscape orientation for
						detailed view.
					</p>
				) : null}
				<Modal
					show={averageCostModal !== null}
					onHide={this.handleSetAverageCostModalClose}
				>
					<SetAverageCostModal
						{...averageCostModal}
						onClose={this.handleSetAverageCostModalClose}
						uid={uid}
					/>
				</Modal>
				{uid ? (
					<Checkbox
						className="show-zero-quantity-checkbox"
						checked={!shouldHideZeroBalances}
						onClick={this.handleShouldHideZeroBalancesClick}
					>
						Show assets with zero balance
					</Checkbox>
				) : null}
			</div>
		)
	}

	renderHoldingsTableHeader(h, name) {
		if (this.props.isPremium) {
			return (
				<th key={h} className={name} onClick={() => this.sortHoldings(h[1])}>
					{h[0]}
				</th>
			)
		}
		return (
			<OverlayTrigger
				key={h}
				placement="bottom"
				overlay={
					<Tooltip id="upgrade-required">
						<span>Get Pro to sort these values.</span>
					</Tooltip>
				}
			>
				<th className={name}>{h[0]}</th>
			</OverlayTrigger>
		)
	}

	renderHoldingsTableHeaderCompact(h, name) {
		if (h[1] !== "name" && h[1] !== "price" && h[1] !== "gainValue") {
			return null
		}
		return (
			<th
				key={h}
				className={h[1] === "gainValue" ? "text-align-right" : name}
				onClick={() => this.sortHoldings(h[1])}
			>
				{h[0]}
			</th>
		)
	}

	addRenderData(holding) {
		const {
			exchangeID,
			exchange,
			name,
			averageCost,
			bookValue,
			marketValue,
			portfolioPercent,
			price,
			quote,
			quantity,
		} = holding
		const { isPremium } = this.props
		const averageCostOverride =
			this.state.averageCost &&
			this.state.averageCost[exchangeID] &&
			this.state.averageCost[exchangeID][name]
				? this.state.averageCost[exchangeID][name]
				: null
		holding.render = {
			exchangeID,
			averageCostNumber: averageCost,
			averageCost: averageCostOverride ? (
				<a
					className="cursor-pointer"
					onClick={this.setAverageCostClickHandler(
						exchangeID,
						exchange,
						name,
						averageCostOverride.quote,
						averageCostOverride.price
					)}
				>
					{formatPrice(
						averageCostOverride.quote,
						averageCostOverride.price,
						true,
						false
					)}
				</a>
			) : averageCost !== null ? (
				formatPrice(quote, averageCost, isPremium)
			) : quantity !== 0 ? (
				<a
					className="set-average-cost-button"
					onClick={this.setAverageCostClickHandler(
						exchangeID,
						exchange,
						name,
						quote
					)}
				>
					Set
				</a>
			) : (
				<span>N/A</span>
			),
			bookValue: formatPrice(quote, bookValue, isPremium),
			gain: formatGain(quote, marketValue, bookValue, isPremium),
			marketValue: formatPrice(quote, marketValue, isPremium),
			portfolioPercent: `${(portfolioPercent * 100).toFixed(2)}%`,
			price: formatPrice(quote, price, true),
			quantity,
			quote,
		}
	}

	formatTableData(tabExchange) {
		const {
			accordionOpenMap,
			isCompact,
			renderHoldings,
			shouldHideZeroBalances,
		} = this.state
		const { holdingsFilter, isPremium } = this.props
		const data = []
		Object.keys(renderHoldings).forEach(function(keyName) {
			const holding = renderHoldings[keyName]
			const { exchange = "None", name } = holding
			const key = exchange.concat(name)
			const inTab = tabExchange === "All" || tabExchange === exchange
			const inFilter =
				holdingsFilter === "" ||
				name.toLowerCase().includes(holdingsFilter.toLowerCase())
			if (
				!inTab ||
				!inFilter ||
				(tabExchange === "All" && exchange === "Combined")
			) {
				return false
			}
			const {
				exchangeID,
				averageCostNumber,
				averageCost,
				bookValue,
				gain,
				marketValue,
				portfolioPercent,
				price,
				quantity,
				quote,
			} = holding.render
			if (shouldHideZeroBalances && quantity <= 0.0000001) {
				return
			}
			if (!isCompact) {
				data.push(
					<tr key={[exchange, name].join()}>
						<td
							onClick={() => this.toggleAccordion(key)}
							className="accordion-opener"
						>
							<Glyphicon
								glyph={accordionOpenMap[key] ? "menu-down" : "menu-right"}
								className="glyphicon-exchange-dropdown"
							/>{" "}
							{exchange}
						</td>
						<td
							className="cursor-pointer"
							onClick={() => this.toggleAccordion(key)}
						>
							<a>{name}</a>
						</td>
						<td>{quantity}</td>
						<td>{price}</td>
						<td>{averageCost}</td>
						<td>{marketValue}</td>
						<td>{bookValue}</td>
						<td>{gain}</td>
						<td>{portfolioPercent}</td>
					</tr>
				)
				if (accordionOpenMap[key]) {
					if (this.props.uid === null) {
						data.push(
							<td colSpan="9" key={key.concat("-orders")} className="td-order">
								<Well className="transactions-well">
									<p>
										Your transactions will be displayed here when signed in.
									</p>
								</Well>
							</td>
						)
					} else {
						data.push(
							<td colSpan="9" key={key.concat("-orders")} className="td-order">
								<Well className="transactions-well">
									<TransactionsTable
										uid={this.props.uid}
										accounts={exchangeID.split(",")}
										symbol={name}
										quote={quote}
										averageCost={averageCostNumber}
										isPremium={isPremium}
									/>
								</Well>
							</td>
						)
					}
				}
			} else {
				return data.push(
					<tr key={[exchange, name].join()}>
						<td>{name}</td>
						<td>{price}</td>
						<td className="text-align-right">{gain}</td>
					</tr>
				)
			}
		}, this)
		return data
	}

	toggleAccordion = key => {
		const { accordionOpenMap } = this.state
		const old = accordionOpenMap[key]
		accordionOpenMap[key] = !old
		this.setState({
			accordionOpenMap: accordionOpenMap,
		})
	}

	handleWindowResize = event => {
		this.setState({
			isCompact: isSmallWindow(),
		})
	}

	setAverageCostClickHandler(exchangeID, exchange, asset, quote, price = null) {
		return () => {
			this.setState({
				averageCostModal: {
					exchangeID,
					exchange,
					asset,
					quote,
					price,
				},
			})
		}
	}

	handleSetAverageCostModalClose = () => {
		this.setState({
			averageCostModal: null,
		})
	}

	handleShouldHideZeroBalancesClick = async event => {
		const value = !event.currentTarget.checked
		const db = firebase.firestore()
		await db
			.collection("settings")
			.doc(this.props.uid)
			.set(
				{
					shouldHideZeroBalances: value,
				},
				{ merge: true }
			)
	}
}

function isSmallWindow() {
	return window.innerWidth < 480
}

class SetAverageCostModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			value: props.price ? props.price.toString() : "",
			quote: props.quote ? props.quote : "USD",
			isSubmitting: false,
			error: null,
		}
	}

	render() {
		const { isSubmitting, quote, value, error } = this.state
		const { exchange, asset, onClose } = this.props
		return (
			<div>
				<Modal.Header closeButton>
					<Modal.Title>
						Set average cost for {asset} on {exchange}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form inline onSubmit={this.handleSubmit}>
						<FormGroup controlId="averageCostQuote">
							<FormControl
								componentClass="select"
								onChange={this.handleQuoteChange}
								value={quote}
							>
								<option value="USD">USD</option>
								<option value="EUR">EUR</option>
								<option value="BTC">BTC</option>
								<option value="ETH">ETH</option>
							</FormControl>
							<FormControl.Feedback />
						</FormGroup>{" "}
						<FormGroup controlId="averageCostValue">
							<FormControl
								type="number"
								value={value}
								onChange={this.handleValueChange}
								min={0}
								autoFocus
							/>
							<FormControl.Feedback />
						</FormGroup>
						<HelpBlock>Set your average cost per unit.</HelpBlock>
					</Form>
					{error !== null ? <Alert bsStyle="danger">{error}</Alert> : null}
				</Modal.Body>
				<Modal.Footer>
					<Button disabled={isSubmitting} onClick={onClose}>
						Cancel
					</Button>
					{this.props.price ? (
						<Button
							disabled={isSubmitting}
							onClick={this.handleDelete}
							bsStyle="danger"
						>
							Delete
						</Button>
					) : null}
					<Button
						disabled={isSubmitting}
						onClick={this.handleSubmit}
						bsStyle="primary"
					>
						{isSubmitting ? "Setting..." : "Set"}
					</Button>
				</Modal.Footer>
			</div>
		)
	}

	handleValueChange = event => {
		this.setState({
			value: event.target.value,
		})
	}

	handleQuoteChange = event => {
		this.setState({
			quote: event.target.value,
		})
	}

	handleSubmit = async event => {
		const { exchangeID, asset, uid, onClose } = this.props
		const { quote, value } = this.state
		this.setState({
			isSubmitting: true,
		})
		const db = firebase.firestore()
		try {
			await db
				.collection("settings")
				.doc(uid)
				.set(
					{
						averageCost: {
							[exchangeID]: {
								[asset]: {
									quote,
									price: Number.parseFloat(value),
								},
							},
						},
					},
					{ merge: true }
				)
			onClose()
		} catch (error) {
			this.setState({
				error: `Couldn't set average cost: ${error.message}`,
			})
			throw error
		} finally {
			this.setState({
				isSubmitting: false,
			})
		}
	}

	handleDelete = async event => {
		const { exchangeID, asset, uid, onClose } = this.props
		this.setState({
			isSubmitting: true,
		})
		const db = firebase.firestore()
		const path = `averageCost.${exchangeID}.${asset}`
		try {
			await db
				.collection("settings")
				.doc(uid)
				.update({
					[path]: firebase.firestore.FieldValue.delete(),
				})
			onClose()
		} catch (error) {
			this.setState({
				error: `Couldn't delete average cost: ${error.message}`,
			})
			throw error
		} finally {
			this.setState({
				isSubmitting: false,
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/HoldingsTable.js